export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4692.da0926d1.jpg";